<template>
  <el-dialog
    v-loading="loading"
    class="service-packnow-modal"
    width="90%"
    title="当前服务包"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div>
      <div v-for="(pac, idx) in serviceNow" :key="idx" class="package-item">
        <div class="field">
          <label>购买品牌</label><div>{{ pac.brandCodes }}</div>
        </div>
        <div class="field">
          <label>服务内容</label>
          <div>
            <div v-for="(row,ide) in pac.dataSearches" :key="ide">
              {{ row[0] }}：{{ row[1] }}
            </div>
          </div>
        </div>
        <div class="field">
          <label>账号数量</label><div>{{ pac.accountAmount }}</div>
        </div>
        <div class="field">
          <label>购买时间</label><div>{{ pac.buyTime | dateTimeFmt }}</div>
        </div>
        <div class="field">
          <label>生效时间</label><div>{{ pac.startDate | dateFmt }}</div>
        </div>
        <div class="field">
          <label>到期时间</label><div>{{ pac.endDate | dateFmt }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { loadCustomerServiceNow } from '../services'
export default {
  name: 'ServiceOrderNowModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      serviceNow: []
    }
  },
  methods: {
    init (companyId) {
      this.loadData(companyId)
      return this.open()
    },
    loadData (companyId) {
      this.loading = true
      loadCustomerServiceNow(companyId).then((resp) => {
        this.serviceNow = resp
      }).catch(() => {
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.service-packnow-modal
  .el-dialog
    max-width 768px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .field
        display flex
        flex-direction row
        label
          font-weight bold
          width 70px
          flex-shrink 0
          text-align right
          &:after
            content: '\ff1a'
</style>
